import { yupResolver } from "@hookform/resolvers/yup";
import { enqueueSnackbar } from "notistack";
import React from "react";
import { Resolver, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ERole } from "../../../shared/enums/user/ERole";
import { handleError } from "../../../shared/functions/handleError";
import { IUserAction } from "../../../shared/interfaces/user/IUser";
import { UserService } from "../service";
import UserForm from "./UserForm";
import * as yup from "yup";

export const userSchema = yup.object({
  email: yup.string().email("Invalid email").required("validation.required"),

  password: yup
    .string()
    .min(6, "validation.minLength")
    .max(32, "validation.maxLength")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d).+$/,
      "Password must contain at least one letter and one number",
    )
    .optional(),

  role: yup.mixed<ERole>().oneOf(Object.values(ERole)).optional(),

  phoneNumber: yup
    .string()
    .min(3, "validation.minLength")
    .required("validation.required"),

  firstName: yup
    .string()
    .min(3, "validation.minLength")
    .required("validation.required"),

  lastName: yup
    .string()
    .min(3, "validation.minLength")
    .required("validation.required"),
});

const UserCreate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { handleSubmit, control, watch } = useForm<IUserAction>({
    resolver: yupResolver(userSchema) as unknown as Resolver<IUserAction>,
  });

  const submitHandler = (formData: IUserAction) => {
    UserService.create(formData)
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t("toasts.successfullyCreated", { title: formData?.displayName }),
            {
              variant: "success",
            },
          );
        }
      })
      .catch(handleError);
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <UserForm control={control} watch={watch} />
    </form>
  );
};

export default UserCreate;
